import { Badge, Row, Col } from 'reactstrap';
import { useQuery } from '@tanstack/react-query';
import { Link } from '@s20/components/common/Link';
import i18n from '@s20/i18n';
import { httpClient } from '@s20/services/httpClient';
import { getShort } from '@s20/common/util/date';
import { ApiRoutes, AppNavPaths } from '../Common';
import { FormCircularProgress } from '../common/forms/FormElements';

export const EmployeeRecentTimesheetsInfo = ({ employeeId }) => {
    const { data: timesheets, isLoading } = useQuery({
        queryKey: ['recentTimesheetsByEmployee', employeeId],
        queryFn: () => httpClient.js(ApiRoutes.timesheet.recentByEmployee(employeeId)),
        enabled: !!employeeId,
    });

    if (isLoading) {
        return <FormCircularProgress />;
    }

    return (
        <Row>
            <Col>
                <table className="table table-sm table-bordered">
                    <thead className="text-muted">
                        <tr>
                            <th>Job Date</th>
                            <th>Timesheet #</th>
                            <th>Dispatch</th>
                            <th>Work Order #</th>
                            <th
                                className="text-center"
                                style={{ width: '30px' }}
                            />
                        </tr>
                    </thead>
                    <tbody>
                        {!(timesheets ?? []).length ? (
                            <tr>
                                <td
                                    colSpan="5"
                                    className="text-center"
                                >
                                    No recent timesheets found.
                                </td>
                            </tr>
                        ) : (
                            timesheets.map((ts) => (
                                <tr key={ts.timesheetId}>
                                    <td>{getShort(ts.jobDate)}</td>
                                    <td>
                                        {ts.timesheetNumber}
                                        {ts.isNonFlagging && (
                                            <Badge
                                                color="info"
                                                className="ml-2"
                                            >{i18n.t('timesheet:nfBadge')}</Badge>
                                        )}
                                    </td>
                                    <td>{ts.dispatchLocation}</td>
                                    <td>{ts.workOrderNumber}</td>
                                    <td className="text-center">
                                        <Link
                                            to={`${AppNavPaths.TimesheetManagement}?t=${ts.timesheetId}`}
                                            target="_blank"
                                            className="btn btn-sm btn-outline-primary"
                                        >
                                            View
                                        </Link>
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </Col>
        </Row>
    );
};
